export const appConfig = {
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.staging.servicingusa.com/v1',
  userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID || 'us-west-2_1c0qoVi6Q',
  clientId: process.env.REACT_APP_COGNITO_CLIENT_ID || '1n0olhiq0e3m6qaulb1334g2h7',
  region: process.env.REACT_APP_COGNITO_REGION || 'us-west-2',
  env: process.env.NODE_ENV,
  envLabel: 'stage',
  paymentMethodId_BankAccount: 4,
  reCaptchaKey : process.env.REACT_APP_RECAPTCHA_KEY || '6LfJVNgUAAAAACVnic5msfQMRtvGNZyfn7iLgZuw',
  servicingPhone: '(888) 502-8082',
  collectionsPhone: '(888) 502-8085',
  massachusettsErrorPhone: '(855) 855-1626',
  sessionTimeoutInMinutes: 20,
  isInMaintenance: false,
  delay: 6  // sec
};


